<template>
  <div>
    <br />
    <div align="center">
      <img src="../assets/images/logoa.png" class="imgHeight" />
    </div>
    <br />
    <div class="EntryBlock" align="center" width="100%">
      <!-- <input
        type="button"
        id="btnSummaryForm"
        v-if="userTypeID == 1"
        v-on:click="redirectToSummaryForm()"
        value="Status Summary"
        style="font-size: 18px; padding: 5px"
        title="Click here to redirect Status Summary form"
      />
      <input
        type="button"
        id="btnUploadForm"
        v-if="userTypeID != 11"
        v-on:click="redirectToUplodForm()"
        value="File Drive"
        style="font-size: 18px; padding: 5px"
      />
      <input
        type="button"
        id="btnDownloadStatusForm"
        v-if="userTypeID != 11"
        v-on:click="redirectUploadDownloadStatusForm()"
        value="Upload Download Status"
        style="font-size: 18px; padding: 5px"
      />-->
      <ul id="ulHeader">
        <li
          style="border: solid 1px; border-radius: 8px"
          v-for="(row, index) in this.menuList"
          :key="index"
          v-on:click="redirectToForm(row.formName)"
          :title="row.displayName"
        >
          <span :class="'glyphicons ' + row.icon" style></span>
          <br />
          {{ row.displayName }}
        </li>
      </ul>
    </div>
    <div
      v-if="userTypeID == 3 || userTypeID == 4"
      style="text-align: -webkit-center; width: 100%"
      align="center"
    >
      <div class="Flex_Table" style="width: 80%">
        <div class="Flex_Row">
          <div class="Flex_Cell">
            <div>
              <label>
                <input type="radio" name="rdGridType" :value="0" v-model="rdGridType" />
                <!--  v-on:change="ShowFirstLevel()" -->
                Payment
              </label>
              <label>
                <input type="radio" name="rdGridType" :value="1" v-model="rdGridType" />
                <!-- v-on:change="ShowBookingRefund()" -->
                Refund
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="Flex_Table" style="width: 80%" v-if="rdGridType == 0">
        <div class="Flex_Row">
          <div class="Flex_Cell">&nbsp;</div>
        </div>
        <div class="Flex_Row" valign="middle" style="background: #bfcdbe">
          <div>
            <label>
              <input
                type="radio"
                name="rdDateType"
                :value="0"
                v-model="rdDateType"
                v-on:change="GetFirstLevel()"
              />
              Booking Date
            </label>
            <label>
              <input
                type="radio"
                name="rdDateType"
                :value="1"
                v-model="rdDateType"
                v-on:change="GetFirstLevel()"
              />
              Visit Date
            </label>
          </div>
          <div class="Flex_Cell" valign="middle">
            From :&nbsp;
            <span>
              <DateControl style="width: 100%" v-model="FromDate" v-on:change="GetFirstLevel()"></DateControl>
            </span>
          </div>
          <div class="Flex_Cell" valign="middle">
            To :&nbsp;
            <span>
              <DateControl style="width: 100%" v-model="ToDate" v-on:change="GetFirstLevel()"></DateControl>
            </span>
          </div>
          <div class="Flex_Cell" valign="middle">
            <input type="button" @click="PrintFirstLevelPdf()" value="PDF" />
          </div>
          <div class="Flex_Cell" valign="middle">
            <div class="Flex_Cell">
              <!-- <JsonExcel
                name="CandMultiplePost.xls"
                v-if="FirstLevel_List.length > 0"
                :data="FirstLevel_List"
              >
                <input
                  type="button"
                  id="btnExport"
                  value="Export"
                  style="padding: 5px 15px 5px 15px; width: 150px"
                  title=""
                />
              </JsonExcel>-->
              <!-- <input
                type="button"
                @click="PrintFirstLevelExcel()"
                value="Excel"
              />-->
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell">&nbsp;</div>
          </div>
        </div>
        <div class="Flex_Table ekkGrid" v-if="FirstLevel_List.length > 3" style="width: 100%">
          <div class="GridContent">
            <div
              :class="fll.rowTypeID == 0 ? 'Flex_Row HeaderClass' : 'Flex_Row'"
              style="min-height: 35px"
              v-for="(fll, index) in FirstLevel_List.filter(item => {
                return item.rowTypeID != -2;
              })"
              :key="index"
            >
              <div class="Flex_Cell" align="center" valign="middle" style="width: 9%">
                <span>{{ fll.srNo }}</span>
              </div>
              <div class="Flex_Cell" align="center" valign="middle" style="width: 13%">
                <span>{{ fll.fromDate }}</span>
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 13%"
                v-if="fll.col11 != 'X'"
              >
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col11 != 'X' && fll.rowTypeID == 1 && fll.col11 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col11)
                  "
                >{{ fll.col11 }}</span>
                <span
                  v-else-if="fll.col11 != 'X' && fll.rowTypeID == -1"
                  style="font-weight: bold; font-size: 105%"
                >{{ fll.col11 }}</span>
                <span v-else>{{ fll.col11 }}</span>
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 13%"
                v-if="fll.col12 != 'X'"
              >
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col12 != 'X' && fll.rowTypeID == 1 && fll.col11 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col12)
                  "
                >{{ fll.col12 }}</span>
                <span v-else>{{ fll.col12 }}</span>
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 13%"
                v-if="fll.col13 != 'X'"
              >
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col13 != 'X' && fll.rowTypeID == 1 && fll.col11 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col13)
                  "
                >{{ fll.col13 }}</span>
                <span v-else>{{ fll.col13 }}</span>
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 13%"
                v-if="fll.col21 != 'X'"
              >
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col21 != 'X' && fll.rowTypeID == 1 && fll.col21 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col21)
                  "
                >{{ fll.col21 }}</span>
                <span
                  v-else-if="fll.col21 != 'X' && fll.rowTypeID == -1"
                  style="font-weight: bold; font-size: 105%"
                >{{ fll.col21 }}</span>
                <span v-else>{{ fll.col21 }}</span>
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 13%"
                v-if="fll.col22 != 'X'"
              >
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col22 != 'X' && fll.rowTypeID == 1 && fll.col22 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col22)
                  "
                >{{ fll.col22 }}</span>
                <span v-else>{{ fll.col22 }}</span>
              </div>
              <div
                class="Flex_Cell"
                align="center"
                valign="middle"
                style="width: 13%"
                v-if="fll.col23 != 'X'"
              >
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col23 != 'X' && fll.rowTypeID == 1 && fll.col23 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col23)
                  "
                >{{ fll.col23 }}</span>
                <span v-else>{{ fll.col23 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col31 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col31 != 'X' && fll.rowTypeID == 1 && fll.col31 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col31)
                  "
                >{{ fll.col31 }}</span>
                <span
                  v-else-if="fll.col31 != 'X' && fll.rowTypeID == -1"
                  style="font-weight: bold; font-size: 105%"
                >{{ fll.col31 }}</span>
                <span v-else>{{ fll.col31 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col32 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col32 != 'X' && fll.rowTypeID == 1 && fll.col32 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col32)
                  "
                >{{ fll.col32 }}</span>
                <span v-else>{{ fll.col32 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col33 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col33 != 'X' && fll.rowTypeID == 1 && fll.col33 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col33)
                  "
                >{{ fll.col33 }}</span>
                <span v-else>{{ fll.col33 }}</span>
              </div>

              <div class="Flex_Cell" style="width: 43%" align="center" v-if="fll.col41 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col41 != 'X' && fll.rowTypeID == 1 && fll.col41 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col41)
                  "
                >{{ fll.col41 }}</span>
                <span
                  v-else-if="fll.col41 != 'X' && fll.rowTypeID == -1"
                  style="font-weight: bold; font-size: 105%"
                >{{ fll.col41 }}</span>
                <span v-else>{{ fll.col41 }}</span>
              </div>
              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col42 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col42 != 'X' && fll.rowTypeID == 1 && fll.col42 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col42)
                  "
                >{{ fll.col42 }}</span>
                <span v-else>{{ fll.col42 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col43 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col43 != 'X' && fll.rowTypeID == 1 && fll.col43 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col43)
                  "
                >{{ fll.col43 }}</span>
                <span v-else>{{ fll.col43 }}</span>
              </div>

              <div class="Flex_Cell" v-if="fll.col51 != 'X'" align="center" valign="middle">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col51 != 'X' && fll.rowTypeID == 1 && fll.col51 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col51)
                  "
                >{{ fll.col51 }}</span>
                <span
                  v-else-if="fll.col51 != 'X' && fll.rowTypeID == -1"
                  style="font-weight: bold; font-size: 105%"
                >{{ fll.col51 }}</span>
                <span v-else>{{ fll.col51 }}</span>
              </div>
              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col52 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col52 != 'X' && fll.rowTypeID == 1 && fll.col52 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col52)
                  "
                >{{ fll.col52 }}</span>
                <span v-else>{{ fll.col52 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col53 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col53 != 'X' && fll.rowTypeID == 1 && fll.col53 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col53)
                  "
                >{{ fll.col53 }}</span>
                <span v-else>{{ fll.col53 }}</span>
              </div>

              <div class="Flex_Cell" v-if="fll.col61 != 'X'" align="center" valign="middle">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col61 != 'X' && fll.rowTypeID == 1 && fll.col61 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col61)
                  "
                >{{ fll.col61 }}</span>
                <span
                  v-else-if="fll.col61 != 'X' && fll.rowTypeID == -1"
                  style="font-weight: bold; font-size: 105%"
                >{{ fll.col61 }}</span>
                <span v-else>{{ fll.col61 }}</span>
              </div>
              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col62 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col62 != 'X' && fll.rowTypeID == 1 && fll.col62 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col62)
                  "
                >{{ fll.col62 }}</span>
                <span v-else>{{ fll.col62 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col63 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col63 != 'X' && fll.rowTypeID == 1 && fll.col63 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col63)
                  "
                >{{ fll.col63 }}</span>
                <span v-else>{{ fll.col63 }}</span>
              </div>

              <div class="Flex_Cell" v-if="fll.col71 != 'X'" align="center" valign="middle">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col71 != 'X' && fll.rowTypeID == 1 && fll.col71 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col71)
                  "
                >{{ fll.col71 }}</span>
                <span
                  v-else-if="fll.col71 != 'X' && fll.rowTypeID == -1"
                  style="font-weight: bold; font-size: 105%"
                >{{ fll.col71 }}</span>
                <span v-else>{{ fll.col71 }}</span>
              </div>
              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col72 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col72 != 'X' && fll.rowTypeID == 1 && fll.col72 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col72)
                  "
                >{{ fll.col72 }}</span>
                <span v-else>{{ fll.col72 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col73 != 'X'">
                <span
                  title
                  class="numberSpan"
                  v-if="
                    fll.col73 != 'X' && fll.rowTypeID == 1 && fll.col73 != '0'
                  "
                  @click="
                    GetSecondLevel(fll.fromDate, FirstLevel_List[0].col73)
                  "
                >{{ fll.col73 }}</span>
                <span>{{ fll.col73 }}</span>
              </div>
              <div class="Flex_Cell" v-if="fll.col81 != 'X'" align="center" valign="middle">
                <span>{{ fll.col81 }}</span>
              </div>
              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col82 != 'X'">
                <span>{{ fll.col82 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col83 != 'X'">
                <span>{{ fll.col83 }}</span>
              </div>
              <div class="Flex_Cell" v-if="fll.col91 != 'X'" align="center" valign="middle">
                <span>{{ fll.col91 }}</span>
              </div>
              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col92 != 'X'">
                <span>{{ fll.col92 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col93 != 'X'">
                <span>{{ fll.col93 }}</span>
              </div>
              <div class="Flex_Cell" v-if="fll.col101 != 'X'" align="center" valign="middle">
                <span>{{ fll.col101 }}</span>
              </div>
              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col102 != 'X'">
                <span>{{ fll.col102 }}</span>
              </div>

              <div class="Flex_Cell" align="center" valign="middle" v-if="fll.col103 != 'X'">
                <span>{{ fll.col103 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalPopup
        title="Details"
        ref="ModalPopup1"
        @closed="modalPopupClosed"
        @opened="modalPopupShown"
        v-model="secondLevelDiv"
        :okButton="$refs.btnOk"
        :cancelButton="$refs.btnOk"
        style="overflow-y: auto"
      >
        <input type="hidden" v-model="hdnFromDate" id="hdnFromDate" />
        <input type="hidden" v-model="hdnBookingTypeId" id="hdnBookingTypeId" />

        <div class="Flex_Table" style="width: 1000px;max-height: 400px">
          <div class="Flex_Row">
            <!-- <div class="Flex_Cell" v-if="SecondLevel_List.length > 0">
              <b> Booking Date : {{ this.SecondLevel_List[1].col1 }}</b>
            </div>

            <div class="Flex_Cell" v-if="SecondLevel_List.length > 0">
              <b> Travel Date : {{ this.SecondLevel_List[1].col2 }}</b>
            </div>-->
            <div class="Flex_Cell" v-if="SecondLevel_List.length > 0">
              <b>Booking Type : {{ this.SecondLevel_List[1].col3 }}</b>
            </div>
            <div class="Flex_Cell">
              <select id="ddlType" v-model="ViewTypeID" v-on:change="GetSecondLevelWithOutPopUp()">
                <option
                  v-for="m in IILevelOptions_List"
                  :key="m.iiLevelOptionID"
                  v-bind:value="m.iiLevelOptionID"
                >{{ m.iiLevelOptionName }}</option>
              </select>
            </div>
            <div class="Flex_Cell" valign="middle">
              <input type="button" @click="PrintSecondLevelPdf()" value="PDF" />
            </div>
          </div>
          <div class="Flex_Row">
            <div class="Flex_Cell">
              <div class="Flex_Table ekkGrid">
                <div
                  :class="
                    sll.rowTypeID == 0 ? 'Flex_Row HeaderClass' : 'Flex_Row'
                  "
                  v-for="(sll, index) in SecondLevel_List"
                  :key="index"
                >
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.srNo != 'X'"
                    v-bind:style="WidthOfColLastStr"
                  >
                    <span>{{ sll.srNo }}</span>
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.col1 != 'X'"
                    v-bind:style="WidthOfColStr"
                  >
                    <span>{{ sll.col1 }}</span>
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.col2 != 'X'"
                    v-bind:style="WidthOfColStr"
                  >
                    <span>{{ sll.col2 }}</span>
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.col4 != 'X'"
                    v-bind:style="WidthOfColStr"
                  >
                    <span>{{ sll.col4 }}</span>
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.col5 != 'X'"
                    v-bind:style="WidthOfColStr"
                  >
                    <span>{{ sll.col5 }}</span>
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.col6 != 'X'"
                    v-bind:style="WidthOfColStr"
                  >
                    <span>{{ sll.col6 }}</span>
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.col7 != 'X'"
                    v-bind:style="WidthOfColStr"
                  >
                    <span>{{ sll.col7 }}</span>
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.col8 != 'X'"
                    v-bind:style="WidthOfColStr"
                  >
                    <span>{{ sll.col8 }}</span>
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.col9 != 'X'"
                    v-bind:style="WidthOfColStr"
                  >
                    <span>{{ sll.col9 }}</span>
                  </div>
                  <div
                    class="Flex_Cell"
                    align="center"
                    valign="middle"
                    v-if="sll.col10 != 'X'"
                    v-bind:style="WidthOfColStr"
                  >
                    <span>{{ sll.col10 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalPopup>
      <div class="Flex_Table" style="width:80%" v-if="rdGridType == 1">
        <div class="Flex_Row">
          <div class="Flex_Cell">&nbsp;</div>
        </div>
        <div class="Flex_Row" valign="middle" style="background: #bfcdbe">
          <div class="Flex_Cell" valign="middle">
            From :&nbsp;
            <span>
              <DateControl
                style="width: 100%"
                v-model="FromDateRefund"
                v-on:change="GetBookingRefund()"
              ></DateControl>
            </span>
          </div>
          <div class="Flex_Cell" valign="middle">
            To :&nbsp;
            <span>
              <DateControl
                style="width: 100%"
                v-model="ToDateRefund"
                v-on:change="GetBookingRefund()"
              ></DateControl>
            </span>
          </div>
          <div class="Flex_Cell" valign="middle">
            <span>Member Type</span>
            <select id="ddlUserType" v-model="userType" @change="GetBookingRefund()">
              <option value="-1">---All---</option>
              <option v-for="u in userType_List" :key="u[0]" v-bind:value="u[0]">{{ u[1] }}</option>
            </select>
          </div>
          <div class="Flex_Cell" valign="middle">
            <span>Refund Status</span>
            <select id="ddlUserType" v-model="refundStatus" @change="GetBookingRefund()">
              <option value="-1">---All---</option>
              <option value="1">Refunded</option>
              <option value="2">Initiated</option>
            </select>
          </div>
          <div class="Flex_Cell" valign="middle">
            <input type="button" @click="PrintRefundPdf()" value="PDF" />
          </div>
        </div>
        <div class="Flex_Row">
          <div class="Flex_Table ekkGrid">
            <div class="Flex_Row GridHeader" style="vertical-align: middle !important">
              <div class="Flex_Cell" style="width: 4%">Sr.No.</div>
              <div class="Flex_Cell" style="width: 14%">Bank Transaction No.</div>
              <div class="Flex_Cell" style="width: 7%">Refund DateTime</div>
              <div class="Flex_Cell" style="width: 5%">Refund Amount</div>
              <div class="Flex_Cell" style="width: 7%">Member Name</div>
              <div class="Flex_Cell" style="width: 7%">Booking Type</div>
              <div class="Flex_Cell" style="width: 10%">Booking Date/Slot</div>
              <div class="Flex_Cell" style="width: 5%">No. of Head</div>
              <div class="Flex_Cell" style="width: 7%">Booking Amount</div>
              <div class="Flex_Cell" style="width: 15%">Refund Status</div>
              <div class="Flex_Cell" style="width: 12%">Ticket No</div>
              <div class="Flex_Cell" style="width: 7%">Refund Ref. No.</div>
            </div>
            <div class="GridContent" style="height: calc(100vh - 400px)">
              <div
                class="Flex_Row"
                style="min-height: 35px"
                v-for="(row, index) in BookingReport_List"
                :key="index"
              >
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 4%"
                >{{ index + 1 }}</div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 14%"
                >{{ row[3] }}</div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 7%"
                >{{ new Date(row[5]).convertToString("dd MMM yyyy") }}</div>
                <div class="Flex_Cell" align="center" valign="middle" style="width: 5%">{{ row[6] }}</div>
                <div class="Flex_Cell" align="center" valign="middle" style="width: 7%">{{ row[8] }}</div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 7%"
                >{{ row[10] }}</div>
                <div class="Flex_Cell" align="center" valign="middle" style="width: 10%">
                  {{ new Date(row[12]).convertToString("dd MMM yyyy") }}
                  <br />
                  {{ row[13] }}
                </div>

                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 5%"
                >{{ row[14] }}</div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 7%"
                >{{ row[15] }}</div>
                <div class="Flex_Cell" align="center" valign="middle" style="width: 15%">
                  {{ row[16] == 1 ? "Refunded" : "Initiated" }}
                  <br />
                  Reason : {{ row[17] }}
                </div>

                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 12%"
                >{{ row[18] }}</div>

                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 7%"
                >{{ row[20] }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import axios from "axios";
import config from "@/router/globalConfig";
import LoginJs from "./servicesJS/Login.js";
import HomeJs from "./servicesJS/Home.js";
import DateControl from "./ekkControls/DateControl";
import ModalPopup from "./ekkControls/ModalPopup";
import Report from "@/router/Report";
import MasterEntryJS from "./servicesJS/MasterEntry.js";
// import JsonExcel from "vue-json-excel";
export default {
  name: "Home",
  components: {
    DateControl: DateControl,
    ModalPopup: ModalPopup,
    Report: Report
    // JsonExcel: JsonExcel
  },
  data() {
    return {
      notices: [],
      circulars: [],
      userTypeID: -1,
      chk1: false,
      chk2: false,
      chk3: false,
      chk4: false,
      chk5: false,
      chk6: false,
      chk7: false,
      chk8: false,
      chk9: false,
      chk10: false,
      chkAgree: false,
      menuList: [],
      FromDate: new Date(),
      ToDate: new Date().addMonths(6),
      FirstLevel_List: [],
      ViewTypeID: 1,
      SecondLevel_List: [],
      secondLevelDiv: false,
      WidthOfCol: 0,
      WidthOfColStr: "",
      WidthOfColLast: 0,
      WidthOfColLastStr: "",
      hdnFromDate: "",
      hdnBookingTypeId: 1,
      IILevelOptions_List: [],
      rdDateType: 1,
      rdGridType: 0,
      refundStatus: -1,
      userType: -1,
      userType_List: [],
      FromDateRefund: new Date().addMonths(-1),
      ToDateRefund: new Date(),
      BookingReport_List: []
    };
  },
  methods: {
    Agree() {
      if (this.chkAgree == true) {
        this.chk1 = true;
        this.chk2 = true;
        this.chk3 = true;
        this.chk4 = true;
        this.chk5 = true;
        this.chk6 = true;
        this.chk7 = true;
        this.chk8 = true;
        this.chk9 = true;
        this.chk10 = true;
      } else {
        this.chk1 = false;
        this.chk2 = false;
        this.chk3 = false;
        this.chk4 = false;
        this.chk5 = false;
        this.chk6 = false;
        this.chk7 = false;
        this.chk8 = false;
        this.chk9 = false;
        this.chk10 = false;
      }
    },
    // getNotices() {
    //   const authToken = "bearer ".concat(
    //     window.sessionStorage.getItem("token")
    //   );
    //   const antiforgeryToken =
    //     window.sessionStorage.getItem("antiforgery_token");

    //   let NoticeID = -1;
    //   let IsActive = 1;
    //   let NoticeType = 1;
    //   let FromDate = new Date().addDays(-15).convertToString("dd/MMM/yyyy");
    //   let ToDate = new Date().addDays(15).convertToString("dd/MMM/yyyy");
    //   let Type = 1;
    //   axios
    //     .get(config.WEB_API_PATH + "Notice/GetNotice", {
    //       headers: {
    //         __RequestVerificationToken: antiforgeryToken,
    //         Authorization: authToken,
    //       },
    //       params: {
    //         NoticeID: NoticeID,
    //         IsActive: IsActive,
    //         NoticeType: NoticeType,
    //         FromDate: FromDate,
    //         ToDate: ToDate,
    //         Type: Type,
    //       },
    //       crossdomain: true,
    //     })
    //     .then(
    //       (result) => {
    //         this.notices = result.data;
    //       },
    //       (error) => {
    //         alert("Error: " + error);
    //       },
    //       (failure) => {
    //         alert("Failure: " + failure);
    //       }
    //     )
    //     .catch(function (error) {
    //       alert(error);
    //     });
    // },
    // getCirculars() {
    //   const authToken = "bearer ".concat(
    //     window.sessionStorage.getItem("token")
    //   );
    //   const antiforgeryToken =
    //     window.sessionStorage.getItem("antiforgery_token");

    //   let NoticeID = -1;
    //   let IsActive = 1;
    //   let NoticeType = 2;
    //   let FromDate = new Date().addDays(-15).convertToString("dd/MMM/yyyy");
    //   let ToDate = new Date().addDays(15).convertToString("dd/MMM/yyyy");
    //   let Type = 1;
    //   axios
    //     .get(config.WEB_API_PATH + "Notice/GetNotice", {
    //       headers: {
    //         __RequestVerificationToken: antiforgeryToken,
    //         Authorization: authToken,
    //       },
    //       params: {
    //         NoticeID: NoticeID,
    //         IsActive: IsActive,
    //         NoticeType: NoticeType,
    //         FromDate: FromDate,
    //         ToDate: ToDate,
    //         Type: Type,
    //       },
    //       crossdomain: true,
    //     })
    //     .then(
    //       (result) => {
    //         this.circulars = result.data;
    //       },
    //       (error) => {
    //         alert("Error: " + error);
    //       },
    //       (failure) => {
    //         alert("Failure: " + failure);
    //       }
    //     )
    //     .catch(function (error) {
    //       alert(error);
    //     });
    // },
    // getCandidateApp() {
    //   this.candApplication_List = [];
    //   const _data_ = { advtID: -1, type: 1 };
    //   axios
    //     .get(config.WEB_API_PATH + "Registration/GetCandApplication", {
    //       headers: {
    //         __RequestVerificationToken: config.AF_Token,
    //         Authorization: config.LOG_Token,
    //       },
    //       params: _data_,
    //       crossdomain: true,
    //     })
    //     .then(
    //       (response) => {
    //         this.candApplication_List = response.data.result;
    //         if (response.data.result.length > 0) {
    //           this.chkAgree = true;
    //           this.chk1 = true;
    //           this.chk2 = true;
    //           this.chk3 = true;
    //           this.chk4 = true;
    //           this.chk5 = true;
    //           this.chk6 = true;
    //           this.chk7 = true;
    //           this.chk8 = true;
    //           this.chk9 = true;
    //           this.chk10 = true;
    //           this.redirectToAppForm();
    //         } else {
    //           this.chkAgree = false;
    //           this.chk1 = false;
    //           this.chk2 = false;
    //           this.chk3 = false;
    //           this.chk4 = false;
    //           this.chk5 = false;
    //           this.chk6 = false;
    //           this.chk7 = false;
    //           this.chk8 = false;
    //           this.chk9 = false;
    //           this.chk10 = false;
    //         }
    //       },
    //       (error) => {}
    //     );
    // },
    redirectToAppForm() {
      //this.$router.push({ name: "Application" });
      if (
        this.chk1 == false ||
        this.chk2 == false ||
        this.chk3 == false ||
        this.chk4 == false ||
        this.chk5 == false ||
        this.chk6 == false ||
        this.chk7 == false ||
        this.chk8 == false ||
        this.chk9 == false ||
        this.chk10 == false
      ) {
        alert(
          "Please agree you have read and understood the mentioned instructions."
        );
        return;
      }
      this.$router.push({ name: "Home" });
    },
    // redirectToSummaryForm() {
    //   this.$router.push({ name: "StatusSummary" });
    // },
    // redirectToUplodForm() {
    //   this.$router.push({ name: "FileDrive" });
    // },

    redirectToMyBookingForm() {
      this.$router.push({ name: "MyBooking" });
    },

    redirectToScanTicketForm() {
      this.$router.push({ name: "ScanTicket" });
    },
    // redirectUploadDownloadStatusForm() {
    //   this.$router.push({ name: "UploadDownloadStatus" });
    // },
    fillUserData() {
      LoginJs.GetCurrentUser().then(
        response => {
          if (response.data) {
            this.userTypeID = response.data.userTypeID;
            if (this.userTypeID == 11) {
              this.getCandidateApp();
            }
            //console.log(response.data);
          }
        },
        error => {}
      );
    },
    redirectToMasterEntry() {
      this.$router.push({ name: "MasterEntry" });
    },
    redirectToUserProfile() {
      this.$router.push({ name: "UserProfile" });
    },
    redirectToForm(FormName) {
      this.$router.push({ name: FormName });
    },
    redirectToSubForm(formID) {
      switch (formID) {
        case 1:
          this.$router.push({ name: "MasterEntry" });
          break;
        case 2:
          this.$router.push({ name: "UserProfile" });
          break;
        case 3:
          this.$router.push({ name: "MyBooking" });
          break;
        case 4:
          this.$router.push({ name: "ScanTicket" });
          break;
        case 5:
          this.$router.push({ name: "TicketBooking" });
          break;
        case 6:
          this.$router.push({ name: "BookingSlots" });
          break;
      }
    },
    getUserRights() {
      let _paramsData = {};
      LoginJs.GetUserRights(_paramsData).then(
        response => {
          if (response.data.formRole.length > 0) {
            this.menuList = response.data.formRole;
            // console.log(response.data);
            // console.log(response.data.formRole);
          }
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure);
        }
      );
    },
    GetFirstLevel() {
      this.FirstLevel_List = [];
      const _data_ = {
        FromDate: this.FromDate.convertToString("dd MMM yyyy"),
        ToDate: this.ToDate.convertToString("dd MMM yyyy"),
        BookingTypeID: 1,
        ViewTypeID: 1,
        Type: 1,
        IsVisitDate: this.rdDateType
      };
      HomeJs.GetFirstLevel(_data_).then(
        response => {
          if (response.data.length > 0) {
            if (response.data) this.FirstLevel_List = response.data;
          }
        },
        error => {}
      );
    },
    GetSecondLevel(FromDate, BookingTypeId) {
      this.hdnFromDate = FromDate;
      this.hdnBookingTypeId = BookingTypeId;
      this.SecondLevel_List = [];
      const _data_ = {
        FromDate: new Date(FromDate).convertToString("dd MMM yyyy"),
        ToDate: new Date(FromDate).convertToString("dd MMM yyyy"),
        BookingTypeID: BookingTypeId,
        ViewTypeID: this.ViewTypeID,
        Type: 2,
        IsVisitDate: this.rdDateType
      };

      HomeJs.GetSecondLevel(_data_).then(
        response => {
          if (response.data.length > 0) {
            if (response.data) this.SecondLevel_List = response.data;
            // console.log(this.SecondLevel_List);
            this.CalculatePopupColumnWidthPer();
            this.openSecondLevelPopup();
          }
        },
        error => {}
      );
    },

    GetSecondLevelWithOutPopUp() {
      this.SecondLevel_List = [];
      const _data_ = {
        FromDate: this.hdnFromDate,
        ToDate: this.hdnFromDate,
        BookingTypeID: this.hdnBookingTypeId,
        ViewTypeID: this.ViewTypeID,
        Type: 2,
        IsVisitDate: this.rdDateType
      };

      HomeJs.GetSecondLevel(_data_).then(
        response => {
          if (response.data.length > 0) {
            if (response.data) this.SecondLevel_List = response.data;
            this.CalculatePopupColumnWidthPer();
          }
        },
        error => {}
      );
    },

    modalPopupClosed(e) {},
    modalPopupShown(e) {},
    openSecondLevelPopup() {
      this.secondLevelDiv = true;
    },
    CalculatePopupColumnWidthPer() {
      let NoOfCol = 0;
      let i = 0;
      let j = 0;
      for (i = 0; i < 1; i++) {
        for (j = 0; j < 1; j++) {
          if (this.SecondLevel_List[0].srNo != "X") {
            NoOfCol = NoOfCol + 1;
          }
          if (this.SecondLevel_List[0].col1 != "X") {
            NoOfCol = NoOfCol + 1;
          }
          if (this.SecondLevel_List[0].col2 != "X") {
            NoOfCol = NoOfCol + 1;
          }
          if (this.SecondLevel_List[0].col4 != "X") {
            NoOfCol = NoOfCol + 1;
          }
          if (this.SecondLevel_List[0].col5 != "X") {
            NoOfCol = NoOfCol + 1;
          }
          if (this.SecondLevel_List[0].col6 != "X") {
            NoOfCol = NoOfCol + 1;
          }
          if (this.SecondLevel_List[0].col7 != "X") {
            NoOfCol = NoOfCol + 1;
          }
          if (this.SecondLevel_List[0].col8 != "X") {
            NoOfCol = NoOfCol + 1;
          }
          if (this.SecondLevel_List[0].col9 != "X") {
            NoOfCol = NoOfCol + 1;
          }
          if (this.SecondLevel_List[0].col10 != "X") {
            NoOfCol = NoOfCol + 1;
          }
        }
      }
      this.WidthOfCol = parseInt(100 / NoOfCol);
      this.WidthOfColStr = { width: this.WidthOfCol + "%" };

      this.WidthOfColLast = parseInt(100 / NoOfCol) + parseInt(100 % NoOfCol);
      this.WidthOfColLastStr = { width: this.WidthOfColLast + "%" };
      // console.log(this.WidthOfColStr);
      // console.log(this.WidthOfColLastStr);
    },

    GetIILevelOptionsForDashboard() {
      this.IILevelOptions_List = [];
      const _data_ = {
        Type: 1
      };
      HomeJs.GetIILevelOptionsForDashboard(_data_).then(
        response => {
          if (response.data.length > 0) {
            if (response.data) this.IILevelOptions_List = response.data;
          }
        },
        error => {}
      );
    },
    PrintFirstLevelPdf() {
      const _data_ = {
        FromDate: this.FromDate,
        ToDate: this.ToDate,
        BookingTypeID: 1,
        ViewTypeID: 1,
        Type: 1,
        IsVisitDate: this.rdDateType
      };
      HomeJs.PrintFirstLevel(_data_).then(
        response => {
          let msg = Report.showReport(response.data.result, false);
          if (msg == false) {
            MessageBox.show({
              message: "No Record Found",
              type: "error",
              title: "API says"
            });
          }
        },
        error => {}
      );
    },
    // PrintFirstLevelExcel() {
    //   const _data_ = {
    //     FromDate: this.FromDate,
    //     ToDate: this.ToDate,
    //     BookingTypeID: 1,
    //     ViewTypeID: 1,
    //     Type: 1,
    //     IsVisitDate: this.rdDateType
    //   };
    //   HomeJs.PrintFirstLevel(_data_).then(
    //     response => {
    //       let msg = Report.showReport(response.data.result, true);
    //       if (msg == false) {
    //         MessageBox.show({
    //           message: "No Record Found",
    //           type: "error",
    //           title: "API says"
    //         });
    //       }
    //     },
    //     error => {}
    //   );
    // },
    PrintSecondLevelPdf() {
      const _data_ = {
        FromDate: this.hdnFromDate,
        ToDate: this.hdnFromDate,
        BookingTypeID: this.hdnBookingTypeId,
        ViewTypeID: this.ViewTypeID,
        Type: 2,
        IsVisitDate: this.rdDateType
      };
      HomeJs.PrintSecondLevel(_data_).then(
        response => {
          let msg = Report.showReport(response.data.result, false);
          if (msg == false) {
            MessageBox.show({
              message: "No Record Found",
              type: "error",
              title: "API says"
            });
          }
        },
        error => {}
      );
    },

    getUserType() {
      const _data_ = { isActive: -1, type: 5 };
      MasterEntryJS.getUserType(_data_).then(
        response => {
          this.userType_List = response.data;
          if (response.data.length > 0) {
          }
        },
        error => {}
      );
    },
    GetBookingRefund() {
      this.BookingReport_List = [];
      const _data_ = {
        FromDate: this.FromDateRefund.convertToString("dd MMM yyyy"),
        ToDate: this.ToDateRefund.convertToString("dd MMM yyyy"),
        BookingTypeID: -1,
        MemberTypeID: this.userType,
        RefundDoneOrInit: this.refundStatus,
        Type: 1
      };
      HomeJs.GetBookingRefund(_data_).then(
        response => {
          if (response.data.length > 0) {
            if (response.data) this.BookingReport_List = response.data;
          } else {
            this.BookingReport_List = [];
          }
        },
        error => {}
      );
    },
    PrintRefundPdf() {
      const _data_ = {
        FromDate: this.FromDateRefund,
        ToDate: this.ToDateRefund,
        BookingTypeID: -1,
        MemberTypeID: this.userType,
        RefundDoneOrInit: this.refundStatus,
        Type: 1
      };
      HomeJs.PrintRefund(_data_).then(
        response => {
          let msg = Report.showReport(response.data.result, false);
          if (msg == false) {
            MessageBox.show({
              message: "No Record Found",
              type: "error",
              title: "API says"
            });
          }
        },
        error => {}
      );
    }
  },
  mounted() {
    this.fillUserData();
    this.getUserRights();
    this.GetFirstLevel();
    this.GetIILevelOptionsForDashboard();
    this.getUserType();
    this.GetBookingRefund();
  },
  watch: {
    FromDate(newValue, oldValue) {
      this.GetFirstLevel();
    },
    ToDate(newValue, oldValue) {
      this.GetFirstLevel();
    },
    FromDateRefund(newValue, oldValue) {
      this.GetBookingRefund();
    },
    ToDateRefund(newValue, oldValue) {
      this.GetBookingRefund();
    }
  }
};
</script>
<style scoped>
.divNoticeList {
  transition: all 500ms ease-in-out;
}

.notice {
  text-align: left;
  padding: 5px;
  position: relative;
}

.notice .entryDate {
  position: absolute;
  right: 10px;
}

.notice .noticeNo {
  font-weight: bold;
}

.notice .noticeTitle {
  font-weight: bold;
  font-size: 110%;
  display: block;
  text-transform: uppercase;
  color: blue;
}

.notice .noticeMsg {
  display: block;
}

.notice .sectionName {
  font-size: 80%;
}

.notice hr {
  margin: 10px 0 0 0;
}

.circular {
  text-align: left;
  padding: 5px;
  position: relative;
}

.circular .entryDate {
  position: absolute;
  right: 10px;
}

.circular .noticeNo {
  font-weight: bold;
}

.circular .noticeTitle {
  font-weight: bold;
  font-size: 110%;
  display: block;
  text-transform: uppercase;
  color: blue;
}

.circular .noticeMsg {
  display: block;
}

.circular .sectionName {
  font-size: 80%;
}

.circular hr {
  margin: 10px 0 0 0;
}

.instruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: 13px;
  margin-bottom: 6px;
  font-weight: bold;
  /* border-bottom: solid thin darkgrey; */
}

.instructionAgree {
  background: floralwhite;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: 13px;
  margin-bottom: 6px;
  font-weight: bold;
  color: #00bb0e;
}

label {
  cursor: pointer;
}

#ulHeader {
  font-size: 18px;
  padding: 15px 0;
  border-top: 1px #ddd solid;
  border-bottom: 1px #ddd solid;
  margin-bottom: 0;
}

#ulHeader li {
  display: inline-block;
  margin: 5px;
  padding: 5px;
  color: #000e52;
  cursor: pointer;
}

#ulHeader li:hover {
  background: #44c5f2;
  color: #fff;
}
</style>
<style>
.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 800px) {
  .imgHeight {
    height: 100%;
  }

  .EntryBlock {
    width: 80%;
  }

  #divApplication {
    display: block;
    height: auto;
  }

  #location {
    width: 70%;
  }

  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }

  .EntryBlock {
    width: 100%;
  }

  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }

  .tblEntryForm {
    width: calc(100vw - 35px);
  }

  /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  }

  /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  }

  /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  }

  /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }

  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }

  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .imgHeight {
    height: 60px;
  }

  .EntryBlock {
    width: calc(100vw - 35px);
  }

  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }

  #location {
    width: 70%;
  }

  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }

  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }

  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }

  .tblEntryForm .divHR {
    display: block;
  }

  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }

  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>
<style>
.numberSpan {
  margin-right: 3px;
  border: solid thin darkgray;
  border-radius: 5px;
  line-height: 25px;
  padding: 0px 8px;
  cursor: pointer;
  display: inline-block;
  /* min-width: 60px;
  max-width: 100%; */
  width: 100%;
  /* min-height: 26px; */
  text-align: center;
}

.sectionName {
  margin-right: 3px;
  cursor: pointer;
  width: 100%;
}

.HeaderClass {
  margin-right: 3px;
  width: 100%;
  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;

  cursor: pointer;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue